<h2 mat-dialog-title>{{ field }} Required</h2>
<div mat-dialog-content>
  <p>{{ field }} is required for this feature. Click the button below to update your profile.</p>
</div>
<br />

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Close</button>
  <button mat-button cdkFocusInitial type="button" [mat-dialog-close]="true">
    Add {{ field }}
  </button>
</div>
